// Pure helper functions for TeamStatsBarChart

import type { ChartPeriod, TeamGameData } from '@parlay-picker/shared/statsChart';
import { getTeamPeriodStats } from '@parlay-picker/shared/statsChart';

export function getValue(game: TeamGameData, propType: string): number {
  if (propType === 'total') return game.gameTotal;
  return game.margin;
}

/** Get value for a specific period, falling back to full-game data */
export function getValueForPeriod(
  game: TeamGameData,
  propType: string,
  period: ChartPeriod,
): { value: number; hasPeriodData: boolean } {
  if (period === 'full') {
    return { value: getValue(game, propType), hasPeriodData: true };
  }

  const periodStats = getTeamPeriodStats(game.quarterScores, period);
  if (!periodStats) {
    return { value: getValue(game, propType), hasPeriodData: false };
  }

  if (propType === 'total') return { value: periodStats.gameTotal, hasPeriodData: true };
  return { value: periodStats.margin, hasPeriodData: true };
}

export function getDirectionLabel(propType: string, isUnderBet: boolean): string {
  if (propType === 'spread') return 'covered';
  if (propType === 'total') return isUnderBet ? 'under' : 'over';
  return 'won';
}

export function formatLineDisplay(value: number, propType: string): string {
  if (propType === 'spread' && value > 0) return `+${value}`;
  return value.toString();
}
